import type { Attributes, Context, Link, SpanKind } from '@opentelemetry/api';
import { SamplingDecision, type Sampler, type SamplingResult } from '@opentelemetry/sdk-trace-web';

// DocumentLoadInstrumentation opens a resourceFetch span per script/css/image, so a
// code-split SPA mints dozens per cold load that nobody queries.
const DROPPED_SPAN_NAMES = new Set(['resourceFetch']);

const RECORD: SamplingResult = { decision: SamplingDecision.RECORD_AND_SAMPLED };
const DROP: SamplingResult = { decision: SamplingDecision.NOT_RECORD };

/**
 * Deliberately NOT wrapped in ParentBasedSampler: the spans being dropped are children
 * of documentLoad, and parent-based sampling would re-admit every one of them.
 */
export class DropNoisySpansSampler implements Sampler {
    public shouldSample(
        _context: Context,
        _traceId: string,
        spanName: string,
        _spanKind: SpanKind,
        _attributes: Attributes,
        _links: Link[]
    ): SamplingResult {
        return DROPPED_SPAN_NAMES.has(spanName) ? DROP : RECORD;
    }

    public toString(): string {
        return 'DropNoisySpansSampler';
    }
}
